import axios from 'axios';
import store from '../../../store'
// import { API } from '../../../api/config/api'

// var urlsApi = API
// var response = JSON.parse(localStorage.getItem('response')) 
// let urlsApi = response ? response.Empresas[localStorage.getItem('INDEXEMPRESA')].api : '';

export class resourceSolicitacoes {
  static getListaSolicitacoes () {
      return axios.get(store.state.api + 'solicitacoes' )
  }
  static getSolicitacao (id) {
    return axios.get(store.state.api + 'solicitacoes/' + id)
  }
  static getEstados () {
      return axios.get(store.state.api + 'solicitacoes/status' )
  }
  static atualizaEstado (id, estado) {
    return axios.put(store.state.api + 'solicitacoes/' + id , estado)
  }
}

export default resourceSolicitacoes



// WEBPACK FOOTER //
// ./src/components/views/Solicitacoes/resource.js